export default {
  getToken: state => state.token,
  getActiveUser: state => state.activeUser,
  getLoginOtp : state => state.loginOtp,
  getUserList: state => state.user
}
